import { Component, OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WebsocketService } from '../../services/websocket.service';
import { SharedService } from '../../services/shared.service';
import { InventoryRequestService } from '../../../vendor-data/inventory-request-lists/inventory-request.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-inventory-alerts',
  standalone: true,
  templateUrl: './inventory-alerts.component.html',
  styleUrl: './inventory-alerts.component.scss',
  imports: [],
})
export class InventoryAlertsComponent implements OnInit, OnDestroy {
  alerts: any[] = [];
  private sub?: Subscription;

  constructor(
    public bsModalRef: BsModalRef,
    private websocketService: WebsocketService,
    private sharedService: SharedService,
    private inventoryRequestService: InventoryRequestService
  ) {}

  ngOnInit(): void {
    this.sub = this.websocketService.unreadAlerts$.subscribe((alerts) => {
      // Sort newest first
      this.alerts = alerts.slice().sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  splitVendors(vendor: string): string[] {
    return (vendor || '').split(',').map(v => v.trim()).filter(v => v);
  }

  copyAlert(alert: any): void {
    const upc = alert.upc || '';
    if (!upc) {
      this.sharedService.raiseErrorToast('No UPC available to copy.');
      return;
    }
    
    const text = alert.qty ? `${upc} - Qty: ${alert.qty}` : upc;
    
    navigator.clipboard.writeText(text).then(() => {
      const message = alert.qty ? 'UPC and Quantity copied to clipboard!' : 'UPC copied to clipboard!';
      this.sharedService.raiseSuccessToast(message);
    }).catch(err => {
      console.error('Could not copy text: ', err);
      this.sharedService.raiseErrorToast('Failed to copy to clipboard.');
    });
  }

  dismissAlert(alert: any): void {
    this.websocketService.removeAlert(alert.upc);
    this.closeAlertOnServer(alert);
  }

  clearAll(): void {
    this.alerts.forEach((alert) => this.closeAlertOnServer(alert));
    this.websocketService.clearAlerts();
    this.bsModalRef.hide();
  }

  // Best-effort: persists the close server-side so the webhook stops
  // re-broadcasting this alert. Local removal above already gives the user
  // immediate feedback even if this fails or the alert predates alert_id.
  private closeAlertOnServer(alert: any): void {
    if (!alert.alert_id) {
      return;
    }
    this.inventoryRequestService.closeInventoryAlert(alert.alert_id).subscribe({
      error: (err) => console.error('Failed to close inventory alert:', err),
    });
  }
}
